import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  scroller: {
    base: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: theme.settings.zLayers.foreground,
      opacity: 0,
      height: '100vh',
      overflow: 'auto',
      transition: `opacity 250ms ${theme.settings.timingFunctions.easeInOutBack}, background-color 150ms ${theme.settings.timingFunctions.easeInOutQuad}`,
      pointerEvents: 'none',
    },

    visible: {
      opacity: 1,
      pointerEvents: 'auto',
    },
  },

  aligner: {
    base: {
      minHeight: '100%',
    },
  },

  shield: {
    base: {
      backgroundColor: theme.colors.backgrounds.overlay,
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
  },
})
